import { Injectable } from "@angular/core";
import { FileUpload } from "../models/file-upload";
import { Observable } from "rxjs";
import { ServiceUtil } from "../util/service.util";
import { HttpService } from "ems-oauth2-client";
import { map, catchError, publishReplay, refCount } from 'rxjs/operators';

@Injectable()
export class FileUploadService extends ServiceUtil {
  private url = "/questionario/resposta_item_arquivo";

  constructor(private http: HttpService) {
    super();
  }

  // recupera por id
  getId(id: number): Observable<FileUpload> {
    return this.http
      .get(this.url + "/" + id)
      .pipe(map(response =>  response),
       catchError(this.handleError),
       publishReplay(1),
       refCount());
  }

  // altera ou inclui FileUpload
  update(fileUpload: FileUpload): Observable<FileUpload> {
    let body = JSON.stringify(fileUpload);

    return this.http
      .post(this.url, body)
      .pipe(map(response =>  response),
       catchError(this.handleError),
       publishReplay(1),
       refCount());
  }

  // deleta FileUpload
  deletar(fileUpload: FileUpload): Observable<FileUpload> {
    return this.http
      .delete(this.url + "/" + fileUpload.id)
      .pipe(map(response =>  response),
       catchError(this.handleError),
       publishReplay(1),
       refCount());
  }

}
